import { render, staticRenderFns } from "./pi-card-block.vue?vue&type=template&id=23aeff46&"
import script from "./pi-card-block.vue?vue&type=script&lang=js&"
export * from "./pi-card-block.vue?vue&type=script&lang=js&"
import style0 from "./pi-card-block.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports